// extracted by mini-css-extract-plugin
module.exports = {"pageHead":"PostFull_pageHead__2kE7j","mainImg":"PostFull_mainImg__sXs5V","featuredImageContainer":"PostFull_featuredImageContainer__1np0u","fullTitle":"PostFull_fullTitle__2Gt9k"};